import { Buyer } from '@40seas/entities/buyers';
import { Executor, FromSchema } from '@40seas/entities/common';
import { Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const HeronCompanySchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string().or(Buyer['schema']),
        heronId: z.string(),
    }),
).strict();

export class HeronCompany extends FromSchema(HeronCompanySchema) implements SegmentEntity {
    id: string;
    buyer: string;
    heronId: string;

    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    seller?: string;
    segments?: Segment[];
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class MultiTenantHeronCompany extends HeronCompany {}
